import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import classNames from 'classnames'
import _ from 'lodash'

import styles from './VisaoPorAuditorCard.module.css'
import { sistemas } from '../../../controllers/itensController'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import { grey } from '@mui/material/colors'

export const VisaoPorAuditorDocumentosCard = ({
  itens,
  handleIndicadorComponentClick,
  handleIndicadorComponentItemContextMenuOpen
}) => {
  const {
    visao: {
      documentosPorServidor: { documentosPorFuncaoServidor, gruposAgregadores, total }
    }
  } = itens

  const renderDocumentosPorSituacao = ({ descricao, documentosPorSituacoes }) =>
    _.map(
      documentosPorSituacoes,
      ({ identificador, codigo, descricao: descricaSituacao, enfatizar, total }, key) => (
        <Grid
          item
          xs={12}
          lg={6}
          key={key}
          onClick={() =>
            handleIndicadorComponentClick(
              { identificador, descricao: `${descricao} - ${descricaSituacao}` },
              null,
              '_blank',
              sistemas.documentos
            )
          }
          onContextMenu={(event) =>
            handleIndicadorComponentItemContextMenuOpen(
              event,
              { indicador: { identificador, descricao: `${descricao} - ${descricaSituacao}` } },
              sistemas.documentos
            )
          }>
          <Tooltip title={descricaSituacao}>
            <Box
              width={1}
              display='flex'
              style={{ cursor: 'pointer', backgroundColor: grey[200], borderRadius: '4px' }}>
              <Box style={{ flexGrow: 1 }} px={2}>
                <Typography
                  variant='subtitle2'
                  noWrap
                  style={{
                    paddingTop: '4px',
                    maxWidth: '300px',
                    fontWeight: enfatizar ? 600 : 400
                  }}>
                  {descricaSituacao}
                </Typography>
                <Typography variant='body2' color='textSecondary' style={{ fontSize: '0.7rem' }}>
                  {descricao}
                </Typography>
              </Box>
              <Box className={classNames(styles.numeradorBoxMeusDocumentos, styles.totalBox)}>
                <Typography
                  variant='body2'
                  color='white'
                  style={{ textAlign: 'center', fontWeight: '100', fontSize: '1.45rem' }}>
                  {total}
                </Typography>
              </Box>
            </Box>
          </Tooltip>
        </Grid>
      )
    )

  return (
    <Card style={{ borderRadius: '12px', paddingTop: '3px', paddingBottom: '5px' }}>
      <Box px={2} py={1}>
        <Box width={1} px={1} display='flex' alignItems='center'>
          <Box style={{ flexGrow: 1 }}>
            <Typography color='textPrimary' className={styles.removeMargin} gutterBottom>
              Meus documentos
            </Typography>
          </Box>
          {total === 0 && (
            <Box className={classNames(styles.numeradorBoxVazio, styles.totalBox)}>
              <Typography
                variant='body2'
                color='white'
                style={{ textAlign: 'center', fontWeight: '100', fontSize: '1.45rem' }}>
                00
              </Typography>
            </Box>
          )}
        </Box>
        <Grid item xs={12} container spacing={1} className={styles.noMargin}>
          {_.map(gruposAgregadores, ({ titulo, agregadores }, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12}>
                <Typography
                  color='textPrimary'
                  style={{ marginLeft: '20px', marginTop: '8px', fontWeight: '300' }}
                  gutterBottom>
                  {titulo}
                </Typography>
              </Grid>
              <Grid container item xs={12} spacing={1}>
                {_.map(
                  _.filter(documentosPorFuncaoServidor, ({ agregador }) =>
                    _.includes(agregadores, agregador)
                  ),
                  ({ descricao, documentosPorSituacoes }) =>
                    renderDocumentosPorSituacao({ descricao, documentosPorSituacoes })
                )}
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Card>
  )
}

const mapStateToProps = ({ filtros, itens }) => ({ filtros, itens })

const reduxEnhanced = connect(mapStateToProps)(VisaoPorAuditorDocumentosCard)

export default withRouter(reduxEnhanced)
